import React, { useEffect, useRef, useState } from "react";
import HeaderPrintForm from "../../PrintForm/HeaderPrintForm/HeaderPrintForm";
import { Button, Col, Row } from "antd";
import ReactToPrint from "react-to-print";
import { FORMAT_TIME } from "types/enums";
import { birthday2Age, formatDateToString, getAge } from "helper/common";
import Notification from "../../notification/notification";
import Sign from "../../PrintForm/Sign/Sign";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import "./ElectroPrintModal.scss";
import electrocardiographyService from "api/electrocardiography";
import { getText } from "helper/convertHtmlToText";
import {
  setDataElectrocardiography,
  setDetailprintElectro,
} from "redux/reducer/electrocardiography";
import inpatientService from "api/inpatientTreatment";
import BoxBHYT from "pages/Pay/PayTab/ModalPrintPTT/BoxBHYT/BoxBHYT";

const ElectroModal = (props) => {
  const printRef = useRef<any>();
  const { closeModal } = props;
  const idElectro = useAppSelector(
    (e) => e.electrocardiography.idElectrocardiography
  );

  const dataPrintElectro = useAppSelector(
    (e) => e.electrocardiography.detailPrint
  );

  const [nameRoom, setNameRoom] = useState<any>();
  const [rooms, setRooms] = useState([]);

  const dispatch = useAppDispatch();

  const getPrintElecto = async () => {
    try {
      if (idElectro != null) {
        const res = await electrocardiographyService.getDetailPrintElectro(
          idElectro
        );

        dispatch(setDetailprintElectro(res));
      } else Notification("error", "Không có thông tin phiếu in");
    } catch (error) {
      Notification("error", "Đã xảy ra lỗi khi lấy thông tin phiếu");
    }
  };

  useEffect(() => {
    if (rooms !== null) {
      const res = rooms.find((e) => e.id === dataPrintElectro?.buong);
      setNameRoom(res);
    }
  }, [rooms, idElectro, dataPrintElectro]);
  const getListBuongSo = async () => {
    const param = {
      page: 1,
      limit: 1000,
    };
    try {
      const res = await inpatientService.getListDanhMucPhongBenh(param);
      setRooms(res.data);
    } catch (error) {
      Notification("error", "Đã xảy ra lỗi khi lấy danh sách buồng");
    }
  };
  useEffect(() => {
    getListBuongSo();
  }, []);

  useEffect(() => {
    getPrintElecto();
  }, [idElectro]);
  const onPrint = () => {
    window.print();
  };
  return (
    <div className="electro-modal">
      <div className="electro-print" ref={printRef}>
        <div>
          <Row>
            <Col span={19}>BỘ Y TẾ</Col>
            <Col span={5}>MS: 23/BV - 01</Col>
          </Row>
          <Row justify={"space-between"}>
            <Col span={19}>BỆNH VIỆN CHUYÊN KHOA MẮT ALINA</Col>
            <Col span={5}>Số: CD_1171/2023.1.1_1</Col>
          </Row>
          <Row
            justify={"center"}
            style={{ fontWeight: "bold", fontSize: "24px", paddingTop: "15px" }}
          >
            PHIẾU ĐIỆN TIM
          </Row>
          <Row
            justify={"center"}
            style={{ fontWeight: "500", fontStyle: "italic" }}
          >
            (lần thứ ......)
          </Row>
          <div style={{ lineHeight: 1.8 }}>
            <Row>
              <Col span={19}>
                Họ tên người bệnh:{" "}
                {dataPrintElectro?.hoTen?.toString()?.toUpperCase()}
              </Col>
              <Col span={5}>
                Tuổi: {birthday2Age(dataPrintElectro?.ngaySinh)}
              </Col>
            </Row>
            <Row>
              <Col span={10}>
                Giới tính:{" "}
                {dataPrintElectro?.gioiTinh === 0
                  ? "Nam"
                  : dataPrintElectro?.gioiTinh === 1
                  ? "Nữ"
                  : null}
              </Col>
              <Col span={9}>
                Cân nặng: {dataPrintElectro?.canNang}{" "}
                <span style={{ paddingLeft: "20px" }}>kg</span>
              </Col>
              <Col span={5}>
                Chiều cao: {dataPrintElectro?.chieuCao}{" "}
                <span style={{ paddingLeft: "20px" }}>cm</span>
              </Col>
            </Row>
            <Row>Địa chỉ: {dataPrintElectro?.diaChiTongHop}</Row>
            <Row>
              Số thẻ BHYT: <BoxBHYT code={dataPrintElectro?.maTheBhyt ?? ""} />
            </Row>
            <Row>
              <Col span={10}>Khoa: Mắt tổng hợp</Col>
              {/* <Col span={9}>Buồng: {nameRoom?.tenPhong}</Col> */}
              {/* <Col span={5}>Giường: {dataPrintElectro?.giuong}</Col> */}
            </Row>
            <Row>
              <Col flex={"80px"}>Chẩn đoán: </Col>
              <Col flex={"auto"}>
                {!dataPrintElectro?.ketLuanDto?.idPhieuKhamNgoaiTru
                  ? dataPrintElectro?.chanDoan
                  : dataPrintElectro?.ketLuanDto?.chiTietKetLuans?.map(
                      (item) => {
                        return (
                          <Row>
                            {item.maIcd} - {item.tenIcd}
                          </Row>
                        );
                      }
                    ) +
                    dataPrintElectro?.ketLuanDto?.chiTietBenhPhuDtos?.map(
                      (item) => {
                        return (
                          <Row>
                            {item.maIcd} - {item.tenIcd}
                          </Row>
                        );
                      }
                    )}
              </Col>
            </Row>
          </div>
          <Row>Yêu cầu kiểm tra: Điện tim thường</Row>
        </div>
        <Sign
          style={{ marginTop: "10px" }}
          label={"Bác sĩ điều trị".toLocaleUpperCase()}
          nguoiThucHien={dataPrintElectro?.bacSyChiDinh ?? ""}
          time={dataPrintElectro?.ngayTao}
        />

        <div className="content2">
          <div className="title">KẾT QUẢ ĐIỆN TIM</div>
          <div style={{ whiteSpace: "pre-line" }}>
            {dataPrintElectro && getText(dataPrintElectro?.moTa)}
          </div>
          <div className="title">
            KẾT LUẬN:{" "}
            <span className="title-sub">{dataPrintElectro?.ketLuan}</span>
          </div>
          <div>
            Lời dặn của bác sĩ chuyên khoa: {dataPrintElectro?.loiDanBacSy}
          </div>
        </div>
        <Sign
          style={{ marginTop: "10px" }}
          label={"Bác sĩ chuyên khoa".toLocaleUpperCase()}
          nguoiThucHien={dataPrintElectro?.nguoiDocKetQua ?? ""}
          time={dataPrintElectro?.ngayTao}
        />
      </div>
      <Row justify={"end"} gutter={[16, 8]}>
        <Col>
          <Button danger onClick={closeModal}>
            Hủy
          </Button>
        </Col>
        <ReactToPrint
          trigger={() => {
            return (
              <Button type="primary" onClick={onPrint}>
                In
              </Button>
            );
          }}
          content={() => printRef.current}
          bodyClass="electro-modal"
          onAfterPrint={closeModal}
        />
      </Row>
    </div>
  );
};

export default ElectroModal;
